<div class="footer_inner">
    <div class="footer_menu">
        <a routerLink="/guide">이용가이드</a>
        <a href="https://www.oasis.co.kr/help/privacy" target="_blank" title="새창" class="emphasis">개인정보처리방침</a>
        <a routerLink="/terms">약관 및 정책</a>
    </div>

    <div class="footer_info" *ngIf="isShowOaisInfo">
        <strong class="footer_company">(주)오아시스</strong>
        <dl class="footer_corp">
            <div class="footer_corp_group">
                <dt class="footer_corp_ttl">서울사무소 :</dt>
                <dd class="footer_corp_desc">서울특별시 종로구 종로1길 50 (중학동, 더케이트윈타워) A동 11층 오아시스마켓</dd>
            </div>
            <div class="footer_corp_group">
                <dt class="footer_corp_ttl">성남본사 :</dt>
                <dd class="footer_corp_desc">경기도 성남시 중원구 갈마치로 218</dd>
            </div>
            <div class="footer_corp_group">
                <dt class="footer_corp_ttl">상호 :</dt>
                <dd class="footer_corp_desc">주식회사 오아시스</dd>
                <dt class="footer_corp_ttl">대표자 :</dt>
                <dd class="footer_corp_desc">안준형</dd>
                <dt class="footer_corp_ttl">사업자등록번호 :</dt>
                <dd class="footer_corp_desc">126-86-45211 <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1268645211" target="_blank" title="새창">사업자정보확인</a></dd>
            </div>
            <div class="footer_corp_group">
              <dt class="footer_corp_ttl">통신판매업신고번호 :</dt>
              <dd class="footer_corp_desc">제 2019-성남중원-0623</dd>
            </div>
        </dl>
    </div>
</div>
